<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header card-gis-filter">
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="1">
            <div class="row p-3">
              <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-2">
                <label>{{ $t('common_words.report_type') }} *</label>
                <br />
                <el-select
                  clearable
                  class="select-primary custom-width-select required-type shadow-sm"
                  size="large"
                  @change="ground = false"
                  v-model="groundForm.type"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    class="select-primary"
                    :value="0"
                    :label="$t('common_words.consolidated')"
                  ></el-option>
                  <el-option
                    class="select-primary"
                    :value="1"
                    :label="$t('common_words.detailed')"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                <label>{{ $t('common_words.farm') }} *</label>
                <br />
                <el-select
                  @change="selectAllFromSelect('groundForm.farms', farms)"
                  clearable
                  multiple
                  v-bind:collapse-tags="true"
                  filterable
                  class="select-primary custom-width-select required-farm shadow-sm"
                  size="large"
                  v-model="groundForm.farms"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="(option, index) in farms"
                    class="select-primary selected-all"
                    :value="option.id"
                    :label="option.name"
                    :key="index + option.id"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                <label>{{ $t('common_words.analyze_by') }} </label>
                <br />
                <el-select
                  clearable
                  @change="changeByInterval"
                  filterable
                  class="select-primary custom-width-select required-farm shadow-sm"
                  size="large"
                  v-model="groundForm.bySel"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="option in optionsInterval"
                    class="select-primary"
                    :value="option.value"
                    :label="option.label"
                    :key="option.value"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-12 col-sm-8 col-md-4 col-lg-4 col-xl-3"
                v-if="groundForm.bySel != 'week' && groundForm.bySel != 'year'"
              >
                <label>{{ $t('common_words.calendar') }}</label>
                <br />
                <el-date-picker
                  v-if="renderComponent"
                  v-model="rangeDate"
                  class="shadow-sm required-year"
                  v-bind:type="typedatepicket"
                  :picker-options="pickerOptions"
                  range-separator="-"
                  :placeholder="`${$t('common_words.select2')}...`"
                  :start-placeholder="$t('common_words.initial_date')"
                  :end-placeholder="$t('common_words.final_date')"
                >
                </el-date-picker>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-right: 0; padding-top: 32px"
                v-if="groundForm.bySel == 'week' || groundForm.bySel == 'year'"
              >
                <el-select
                  clearable
                  @clear="groundForm.week_sel_init = null"
                  filterable
                  class="select-primary custom-width-select required-year shadow-sm"
                  size="large"
                  v-model="groundForm.year_sel_init"
                >
                  <el-option
                    v-for="(option, index) in Object.keys(years).reverse()"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-top: 32px"
                v-if="groundForm.bySel == 'week' && groundForm.year_sel_init"
              >
                <el-select
                  clearable
                  filterable
                  class="select-primary custom-width-select required-week shadow-sm"
                  size="large"
                  v-model="groundForm.week_sel_init"
                >
                  <el-option
                    v-for="(week, index) in years[groundForm.year_sel_init]"
                    class="select-primary"
                    :value="week"
                    :label="week"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-right: 0; padding-top: 32px"
                v-if="groundForm.bySel == 'week' || groundForm.bySel == 'year'"
              >
                <el-select
                  clearable
                  @clear="groundForm.week_sel_end = null"
                  filterable
                  class="select-primary custom-width-select required-year shadow-sm"
                  size="large"
                  v-model="groundForm.year_sel_end"
                >
                  <el-option
                    v-for="(option, index) in Object.keys(years).reverse()"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-top: 32px"
                v-if="groundForm.bySel == 'week' && groundForm.year_sel_end"
              >
                <el-select
                  clearable
                  filterable
                  class="select-primary custom-width-select required-week shadow-sm"
                  size="large"
                  v-model="groundForm.week_sel_end"
                >
                  <el-option
                    v-for="(week, index) in years[groundForm.year_sel_end]"
                    class="select-primary"
                    :value="week"
                    :label="week"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-md-4 col-xl-2">
                <label class="label-primary" style="color: transparent">{{
                  $t('common_words.filter')
                }}</label
                ><br />
                <l-button wide type="info" class="btn-filter" @click="validate">
                  {{ $t('common_words.filter') }}
                </l-button>
              </div>
            </div>
            <br />
          </el-collapse-item>
        </el-collapse>
      </card>
      <br />
      <card
        class="custom-shadow-card-header custom-table-responsive"
        v-if="ground"
        :title="cardTitle"
      >
        <div class="mt-4">
          <div class="row" v-if="isIndex()">
            <div class="table-responsive">
              <table class="table table-striped table-bordered not-last-td">
                <thead class="cusmtom-thead-color">
                  <tr class="cusmtom-thead-color">
                    <td
                      v-for="(row, i) in table_columns"
                      :key="i"
                      class="text-center p-3 custom-header-label"
                      :style="'min-width:150px'"
                    >
                      {{ getColumnLabel(row) }}
                      <br />
                      <span v-if="row.unit">({{ row.unit }})</span>
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in table_data" :key="i">
                    <td
                      class="text-center"
                      v-for="(col, j) in table_columns"
                      :key="j"
                    >
                      {{ row[col.prop] }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions') }}
            </h5>
          </div>
          <div class="row mt-5" style="padding-right: 13px; padding-left: 13px">
            <div class="col-6" v-if="isPDF()">
              <div class="text-right">
                <button
                  class="btn btn-danger custom-shadow-btn"
                  @click="exportToPDF"
                >
                  <em class="fa fa-file-pdf-o"></em>
                  {{ $t('common_words.export_to_pdf') }}
                </button>
              </div>
            </div>
            <div class="col-6" v-if="isExcel()">
              <div class="text-left">
                <button
                  class="btn custom-btn-success custom-shadow-btn"
                  @click="exportToExcel"
                >
                  <em class="fa fa-file-excel-o"></em>
                  {{ $t('common_words.export_to_excel') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { mapActions } from 'vuex';
import { MixinExport } from 'src/mixins/mixin-export';
import { RadioGroup, Radio, RadioButton } from 'element-ui';
import Formatter from 'src/class/Formatter';
import MixinDatePicker from 'src/util/mixinDatePicker';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';

export default {
  components: {
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [RadioButton.name]: RadioButton,
  },

  computed: {
    calendars() {
      if (this.groundForm.farms) {
        let calendars = [];
        this.farms.forEach((element) => {
          this.groundForm.farms.forEach((elFarm) => {
            if (element.id == elFarm) {
              calendars = element.calendars;
            }
          });
        });

        return calendars;
      } else {
        return [];
      }
    },
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },

    cardTitle() {
      return this.groundForm.type == 0
        ? this.$i18n.t('samples.ground_consolidated_report')
        : this.$i18n.t('samples.ground_detailed_report');
    },
    optionsInterval() {
      return {
        0: { label: i18n.t('common_words.day'), value: 'daterange' },
        1: { label: i18n.t('common_words.week'), value: 'week' },
        2: { label: i18n.t('common_words.month'), value: 'monthrange' },
        3: { label: i18n.t('common_words.year'), value: 'year' },
      };
    },
  },

  data() {
    return {
      groundForm: {
        type: null,
        farms: [],
        year_sel_init: null,
        week_sel_init: null,
        year_sel_end: null,
        week_sel_end: null,
        bySel: null,
        year_sel: null,
        user_id: this.$store.state.auth.user.id,
      },
      activeName: '1',
      typedatepicket: 'daterange',
      row: null,
      reports: [],
      interval: 'Semana',
      years: [],
      farms: [],
      valueCollapse: null,
      ground: false,
      table_data: [],
      table_columns: [],
      totals: [],
    };
  },

  mixins: [
    MixinPermissions,
    MixinDatePicker,
    mixinMasters,
    MixinExport,
    MixinMenu,
  ],

  watch: {
    '$i18n.locale': ['forceRerender', 'getSelectAll'],
  },

  methods: {
    getColumnLabel(row) {
      const MAP = {
        bysel: { label: 'common_words.date' },
        type: { label: 'common_words.allotment' },
        farm: { label: 'common_words.farm' },
        depth: { label: 'common_words.depth', suffix: ' (cm)' },
        avg_net_area: { label: 'common_words.net_area', suffix: ' (ha)' },
        crop_variety_name: { label: 'common_words.variety' },
        avg_population: {
          label: 'common_words.population',
          suffix: ' (Plantas/ha)',
        },
        avg_average_weight: {
          label: 'common_words.average_weight',
          suffix: ' (Kg)',
        },
        avg_loss: { label: 'common_words.shrinkage', suffix: ' (%)' },
        avg_return: { label: 'common_words.return' },
        avg_apparent_densitie: { label: 'common_words.bulk_density' },
      };

      if (MAP[row.prop]) {
        const suffix = MAP[row.prop].suffix || '';

        return this.$t(MAP[row.prop].label) + suffix;
      } else {
        return row.label;
      }
    },

    getSelectAll() {
      this.farms = this.concatAll(this.farms.splice(1));
    },

    ...mapActions({
      validationInputsRequired: 'utils/validationInputsRequired',
    }),

    changeByInterval() {
      this.ground = false;
      for (
        let index = 0;
        index < Object.values(this.optionsInterval).length;
        index++
      ) {
        const element = Object.values(this.optionsInterval)[index];
        if (element.label == this.groundForm.bySel) {
          this.typedatepicket = element.value;
          break;
        }
      }
    },

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    validate() {
      if (this.groundForm.type == null) {
        return this.validationInputsRequired('type');
      } else if (
        this.groundForm.farms == null ||
        this.groundForm.farms.length == 0
      ) {
        return this.validationInputsRequired('farm');
      } else if (
        (this.groundForm.bySel == 'year' &&
          (this.groundForm.year_sel_init == null ||
            this.groundForm.year_sel_end == null)) ||
        (this.groundForm.bySel == 'week' &&
          this.isYearSelRequired() &&
          this.groundForm.year_sel_init == null)
      ) {
        return this.validationInputsRequired('year');
      } else if (
        this.isWeekSekRequired() &&
        this.groundForm.week_sel_init == null &&
        this.groundForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('week');
      } else if (
        this.isYearSelRequired() &&
        this.groundForm.year_sel_end == null &&
        this.groundForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('year');
      } else if (
        this.isWeekSekRequired() &&
        this.groundForm.week_sel_end == null &&
        this.groundForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('week');
      } else {
        this.loadRingingJournalReport();
      }
    },

    formatNumber(value) {
      return Formatter.formatNumber(value);
    },

    loadData() {
      let data = {
        type: this.groundForm.type,
        farms: this.groundForm.farms,
        init:
          parseInt(this.groundForm.year_sel_init) * 100 +
          parseInt(this.groundForm.week_sel_init),
        end:
          parseInt(this.groundForm.year_sel_end) * 100 +
          parseInt(this.groundForm.week_sel_end),
        bySel: this.groundForm.bySel,
      };

      switch (this.groundForm.bySel) {
        case 'year':
          data.init = parseInt(this.groundForm.year_sel_init);
          data.end = parseInt(this.groundForm.year_sel_end);
          break;
        case 'monthrange':
          data.init = parseInt(moment(this.rangeDate[0]).format('MM'));
          data.end = parseInt(moment(this.rangeDate[1]).format('MM'));
          break;
        case 'daterange':
          data.init = moment(this.rangeDate[0]).format('YYYY-MM-DD');
          data.end = moment(this.rangeDate[1]).format('YYYY-MM-DD');
          break;
      }

      return data;
    },

    exportToPDF() {
      let data = this.loadData();
      data.route = 'grounds/grounds/reports/pdf';
      data.name_file = `${i18n.t('samples.ground_report')}.pdf`;

      this.PDF(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },

    exportToExcel() {
      let data = this.loadData();
      data.route = 'grounds/grounds/reports/excel/';
      data.name_file = `${i18n.t('samples.ground_report')}.xlsx`;

      this.Excel(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },

    loadRingingJournalReport() {
      this.showHideLoading(true);
      let data = this.loadData();
      data.route = 'grounds/grounds/reports';

      Axios.postMasters(data)
        .then((response) => {
          if (response.data) {
            this.totals = [];
            this.table_columns = response.data.table_columns;
            this.table_data = response.data.table_data;
            if (response.data.message) {
              this.ground = false;
              SweetAlert.warning(response.data.message);
            } else {
              this.ground = true;
            }
          }

          this.showHideLoading();
        })
        .catch((error) => {
          console.log(error);
          this.showHideLoading();
        });
    },

    isYearSelRequired() {
      return this.interval == 'Semana';
    },

    isWeekSekRequired() {
      return this.interval == 'Semana';
    },
  },

  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);

      Axios.getMasters('farms/farms/only')
        .then((response) => {
          this.farms = this.concatAll(response.data.data);
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }

    Axios.getMasters('calendars/getyearsbusiness').then((response) => {
      this.years = response.data;
      this.showHideLoading();
    });

    let current = new Date();
    this.rangeDate = [
      new Date(current.setDate(current.getDate() - current.getDay())),
      new Date(current.setDate(current.getDate() - current.getDay() + 6)),
    ];
  },

  mounted() {
    this.selectedItemOnMenu('grounds');
  },

  destroyed() {
    this.deselectedItemOnMenu('grounds');
  },
};
</script>
<style scoped>
.table-responsive {
  max-height: 80vh;
}

.cusmtom-thead-color {
  position: sticky;
  top: 0;
  z-index: 2;
}

::v-deep .card-title {
  font-weight: 400;
}
</style>
